import React from 'react';
import './index.css'
import { useMediaQuery } from '../../hooks/MediaQuery.hook';

export default function MainDescription() {
    const matches = useMediaQuery('(min-width: 768px)');

    return (
        <div className='home-details no-web-display' style={matches ? { padding: '20px' }:{}}>
            <h1 className='heading'><span className='site-title'>Sports<span className='feed'>Feed</span>24</span> – Best Free Soccer Streams & Live Football Coverage</h1>
            <p className='card-description'>
            Welcome to SportsFeed24, your premier destination for high-quality <strong>free soccer streams</strong> and live football coverage. As the leading platform for <strong>soccer stream</strong> enthusiasts, we provide safe, reliable access to thousands of matches worldwide. Whether you are searching for Premier League action, Champions League drama, or international tournaments, our <strong>football streams</strong> deliver crystal-clear HD quality without costly subscriptions.
            </p>
            
            <h2 className='collection'>Why Choose SportsFeed24 for Soccer Streaming?</h2>
            <table className='card-description' style={{width: '100%', marginBottom: '20px'}}>
                <thead>
                    <tr>
                        <th>Feature</th>
                        <th>Benefit</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td>100% Free Access</td>
                        <td>No subscriptions or hidden fees for our soccer streams</td>
                    </tr>
                    <tr>
                        <td>Multi-Device Support</td>
                        <td>Watch football streams on phones, tablets, PCs, and smart TVs</td>
                    </tr>
                    <tr>
                        <td>Minimal Buffering</td>
                        <td>Optimized servers for smooth soccer stream experience</td>
                    </tr>
                    <tr>
                        <td>Comprehensive Coverage</td>
                        <td>5000+ monthly football streams across all major leagues</td>
                    </tr>
                </tbody>
            </table>

            <h2 className='collection'>Top Soccer Leagues Available for Live Streaming</h2>
            <p className='card-description'>
            SportsFeed24 offers unparalleled access to the worlds most popular <strong>soccer streams</strong>. Our platform covers every major tournament with multiple streaming options:
            </p>
            
            <div>
                <ul>
                    <li>
                        <p>
                            <span className='collection'>Premier League Streams - Most Watched Football League</span>
                        </p>
                        <p className='card-description'>
                        Experience every thrilling moment of the English Premier League with our free <strong>soccer streams</strong>. We provide live coverage of all 380 Premier League matches each season, including:
                        </p>
                        <ul className='card-description'>
                            <li>Manchester United, Liverpool, Arsenal matches</li>
                            <li>Derby days and top-six clashes</li>
                            <li>Relegation battles and title deciders</li>
                        </ul>
                        <p className='card-description'>
                        Check our updated <a href='https://www.sportsfeed24.com/leagues/standings'>Premier League Table</a> for live standings and visit our <a href='https://www.sportsfeed24.com/fixtures/league/Premier League'>fixtures page</a> for match schedules.
                        </p>
                    </li>

                    <li className='nav-item'>
                        <p className='nav-link'>
                            <span className='collection'>Champions League Football Streams</span>
                        </p>
                        <p className='card-description'>
                        Never miss a UEFA Champions League night with our reliable <strong>football streams</strong>. We cover:
                        </p>
                        <ul className='card-description'>
                            <li>All group stage matches (Tuesday/Wednesday nights)</li>
                            <li>Knockout rounds and quarter-finals</li>
                            <li>The grand final with multiple streaming options</li>
                        </ul>
                    </li>

                    <li className='nav-item'>
                        <p className='nav-link'>
                            <span className='collection'>International Soccer Streams</span>
                        </p>
                        <p className='card-description'>
                        From World Cup qualifiers to EURO championships, our platform delivers all major international <strong>soccer streams</strong>:
                        </p>
                        <ul className='card-description'>
                            <li>FIFA World Cup matches</li>
                            <li>UEFA EURO and Copa America</li>
                            <li>International friendlies</li>
                        </ul>
                    </li>
                </ul>
            </div>

            <h2 className='collection'>How to Access Our Soccer Streams</h2>
            <p className='card-description'>
            Watching <strong>football streams</strong> on SportsFeed24 is simple and straightforward:
            </p>
            <ol className='card-description'>
                <li>Visit our homepage for todays live matches</li>
                <li>Select your desired <strong>soccer stream</strong></li>
                <li>Choose from multiple player options</li>
                <li>Enjoy the match in HD quality</li>
            </ol>

            <h2 className='collection'>Soccer Streaming FAQ</h2>
            <div className='card-description'>
                <p><strong>Q: Is it legal to watch soccer streams on SportsFeed24?</strong></p>
                <p>A: We provide information about publicly available streams, similar to a search engine. Always check your local laws regarding streaming.</p>
                
                <p><strong>Q: What devices support your football streams?</strong></p>
                <p>A: Our platform works on all devices including iOS, Android, Windows, and Mac.</p>
                
                <p><strong>Q: Do I need to register for soccer streams?</strong></p>
                <p>A: No registration required - all content is freely accessible.</p>
            </div>

            <h2 className='collection'>Beyond Soccer: Our Sports Coverage</h2>
            <p className='card-description'>
            While specializing in <strong>soccer streams</strong>, SportsFeed24 also offers:
            </p>
            <ul className='card-description'>
                <li><a href='https://www.sportsfeed24.com/fixtures/NFL/NFL'>NFL Streams</a> - Every Sunday game plus playoffs</li>
                <li><a href='https://www.sportsfeed24.com/fixtures/NBA/NBA'>NBA Streams</a> - Regular season and playoffs</li>
                <li><a href='https://www.sportsfeed24.com/fixtures/UFC/UFC'>UFC Streams</a> - Pay-per-view events included</li>
            </ul>

            <h2 className='collection'>Join Millions of Satisfied Streamers</h2>
            <p className='card-description'>
            SportsFeed24 serves over 2 million monthly users seeking quality <strong>football streams</strong>. Our platform is constantly updated to provide:
            </p>
            <ul className='card-description'>
                <li>Faster load times for soccer streams</li>
                <li>More reliable connections</li>
                <li>Broader device compatibility</li>
            </ul>

            <p className='card-description'>
            Bookmark SportsFeed24 today for the best <strong>free soccer stream</strong> experience online. Never miss a match again with our comprehensive football coverage!
            </p>
        </div>
    );
};